import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { WorkLineDto } from '@app/generated/model';
import { WorkLineModel, WorkOrderObjectModel } from '@app/work-order/objects/work-order-object.model';
import { WorkOrderObjectService } from '@app/work-order/objects/work-order-object.service';
import { CableDialogComponent } from '@app/shared/cable-dialog/cable-dialog.component';
import { CableDialogModel } from '@app/shared/cable-dialog/cable-dialog.model';
import { first, filter } from 'rxjs/operators';
import { WorkOrderDetailsService } from '@app/work-order/work-order-details.service';

import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmComponent } from '@app/shared/confirm/confirm.component';
import { ConfirmDialogModel } from '@app/shared/confirm/confirm-dialog.model';
import { Store } from '@ngrx/store';
import { UpdateWorkLineCableLength } from '@dwo/actions';

@Component({
  selector: 'app-work-line-cable',
  templateUrl: './work-line-cable.component.html',
  styleUrls: ['./work-line-cable.component.scss'],
  standalone: false,
})
export class WorkLineCableComponent implements OnInit {
  @Input() workLine: WorkLineDto;
  @Output() selected = new EventEmitter<WorkOrderObjectModel>();

  public selectedChildren: WorkOrderObjectModel[];
  public indentationPerStep = 18;
  public level = 0;
  public indentationStartingPoint = 20;
  constructor(
    private store: Store,
    private translateService: TranslateService,
    private workOrderObjectService: WorkOrderObjectService,
    private workOrderDetailsService: WorkOrderDetailsService,
    private dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.selectedChildren = [];
  }

  showCableDialog(workLine: WorkLineDto) {
    if (workLine.completed) {
      return;
    }

    this.workOrderDetailsService.workOrder$
      .pipe(
        filter((workOrder) => !!workOrder),
        first(),
      )
      .subscribe((workOrder) => {
        const dialogData: CableDialogModel = {
          installedLength: workLine.installedQuantity ?? 0,
          plannedLength: workLine.plannedQuantity ?? 0,
          unit: workLine.unit ?? '',
          material: workLine.material,
        };

        const dialog = this.dialog.open(CableDialogComponent, {
          data: {
            model: dialogData,
            projectId: (workOrder.projectId ?? '').toString(),
          },
        });

        dialog
          .afterClosed()
          .pipe(first())
          .subscribe((result: CableDialogModel) => {
            if (!result) {
              return;
            }

            if (!workLine.id) {
              return;
            }

            const locationExternalIdRaw = result.locationExternalId ?? result.selectedLocationId;
            const externalLocationId = Number(locationExternalIdRaw);
            if (!Number.isInteger(externalLocationId)) {
              return;
            }

            this.store.dispatch(new UpdateWorkLineCableLength(workLine.id, result.installedLength, externalLocationId));
          });
      });
  }

  markAsReopened(workLine: WorkLineDto) {
    const message = this.translateService.instant('workOrderLines.confirmReOpenWarning');
    const confirmMessage = workLine.title;

    const dialog = this.dialog.open(ConfirmComponent, {
      data: {
        message,
        confirmMessage,
      } as ConfirmDialogModel,
    });

    dialog
      .afterClosed()
      .pipe(first())
      .subscribe((result) => {
        if (!result) {
          return;
        }

        //this.workLinesService.markAsOpen(workLine.id);
        this.workOrderDetailsService.setOutdated(true);
      });
  }

  markAsComplete(workLine: WorkLineDto) {
    if (!workLine.installedQuantity) {
      // this.workLinesService.markAsComplete(workLine.id);
      this.workOrderDetailsService.setOutdated(true);
      return;
    }

    const message = this.translateService.instant('workOrderLines.confirmWarning', {
      quantity: workLine.installedQuantity,
      plannedQuantity: workLine.plannedQuantity,
    });
    const confirmMessage = this.translateService.instant('workOrderLines.confirmComplete');

    const dialog = this.dialog.open(ConfirmComponent, {
      data: {
        message,
        confirmMessage,
      } as ConfirmDialogModel,
    });

    dialog
      .afterClosed()
      .pipe(first())
      .subscribe((result) => {
        if (!result) {
          return;
        }

        // this.workLinesService.markAsComplete(workLine.id, workLine.installedQuantity);
        this.workOrderDetailsService.setOutdated(true);
      });
  }

  public toggleSelectedWorkLine(workLine: WorkLineModel) {
    workLine.isSelected = !workLine.isSelected;
    if (!workLine.isSelected) {
      this.workOrderObjectService.addSelectedWorkLine(workLine);
    } else {
      this.workOrderObjectService.removeSelectedWorkLine(workLine);
    }
  }

  public getIndentation(): number {
    return this.indentationStartingPoint + this.indentationPerStep * this.level + this.indentationPerStep;
  }

  // public getProgressLabel(installedQty: number, plannedQty: number): string {
  //   if (!installedQty || !plannedQty || plannedQty <= 0) {
  //     return '0 %';
  //   }
  //   const progress = (installedQty / plannedQty) * 100;
  //   return `${Math.floor(progress).toFixed(0)} %`;
  // }
}
